// extracted by mini-css-extract-plugin
module.exports = {"loading-payment":"styles-module__loading-payment___3v7l5"};